export var LimitedUseResetTypeEnum;
(function (LimitedUseResetTypeEnum) {
    LimitedUseResetTypeEnum[LimitedUseResetTypeEnum["SHORT_REST"] = 1] = "SHORT_REST";
    LimitedUseResetTypeEnum[LimitedUseResetTypeEnum["LONG_REST"] = 2] = "LONG_REST";
    LimitedUseResetTypeEnum[LimitedUseResetTypeEnum["DAWN"] = 3] = "DAWN";
    LimitedUseResetTypeEnum[LimitedUseResetTypeEnum["OTHER"] = 4] = "OTHER";
})(LimitedUseResetTypeEnum || (LimitedUseResetTypeEnum = {}));
export var LimitedUseResetTypeNameEnum;
(function (LimitedUseResetTypeNameEnum) {
    LimitedUseResetTypeNameEnum["SHORT_REST"] = "Short Rest";
    LimitedUseResetTypeNameEnum["LONG_REST"] = "Long Rest";
    LimitedUseResetTypeNameEnum["DAWN"] = "Dawn";
    LimitedUseResetTypeNameEnum["OTHER"] = "Other";
})(LimitedUseResetTypeNameEnum || (LimitedUseResetTypeNameEnum = {}));
export var EntityLimitedUseScaleOperatorEnum;
(function (EntityLimitedUseScaleOperatorEnum) {
    EntityLimitedUseScaleOperatorEnum[EntityLimitedUseScaleOperatorEnum["ADDITION"] = 1] = "ADDITION";
    EntityLimitedUseScaleOperatorEnum[EntityLimitedUseScaleOperatorEnum["MULTIPLICATION"] = 2] = "MULTIPLICATION";
})(EntityLimitedUseScaleOperatorEnum || (EntityLimitedUseScaleOperatorEnum = {}));
